


























import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { SortSetting } from '@/util/SortUtils';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {},
})
export default class MobileSortSelection extends Vue {
  @Prop({required: true})
  private sortOptions!: SortSetting[];

  @Model('change', {type: String})
  private currentSortSetting!: string;

  public displayStringForOption(sortOption: SortSetting): TranslateResult {
    return this.$t('message.sort.' + sortOption.messageCode);
  }

  public isSelectedOption(option: SortSetting): boolean {
    return option.id === this.currentSortSetting;
  }

  public select(setting: SortSetting) {
    this.$emit('change', setting.id);
  }

  public closeSortSelection() {
    this.$emit('close');
  }
}
